import CheckboxFilter from "./CheckboxFilter";
import InputSearch from "../../ui/InputSearch";
import DateRangeFilter from "./DateRangeFilter";

export default function FilterCell({ column, onFilterChange }) {
  const columnFilterValue = column.getFilterValue();
  const { filterVariant } = column.columnDef.meta ?? {};
  const checkboxOptions = column.columnDef.meta?.filterOptions || [];

  switch (filterVariant) {
    case "date":
      return <input type="date" value={columnFilterValue} />;

    case "dateRangeFilter":
      return (
        <DateRangeFilter column={column} onFilterChange={onFilterChange} />
      );
    case "checkboxFilter":
      //prefill selected values for checkbox filter, if there is a filter value, use it, otherwise select all options
      const initialSelected = columnFilterValue?.value;

      return (
        <CheckboxFilter
          options={checkboxOptions}
          selectedValues={initialSelected}
          onChange={(newValues) => {
            // only skip filter if nothing is selected (show all = no filter sent)
            if (newValues.length === 0) {
              column.setFilterValue(undefined);
            } else {
              column.setFilterValue({
                type: "checkboxFilter",
                value: newValues,
              });
            }
          }}
        />
      );
    default: // text filter
      return (
        <InputSearch
          value={columnFilterValue || ""}
          onChange={onFilterChange}
          placeholder="Iskanje..."
        />
      );
  }
}
